import React, { useEffect, useState } from "react";
import {
  Button,
  Spinner,
} from "@fluentui/react-components";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { Dismiss20Regular, Save20Regular } from "@fluentui/react-icons";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getAccessToken } from "../../Services/GraphServices";
import {
  createWorkflow,
  updateWorkflow,
  getWorkflow,
} from "../../Services/HeedifyServices";
import "../CSS/WorkflowsComponent.css";
import WorkflowForm from "./WorkflowForm";
import { useAbility } from "../../Contexts/AbilityContext";

export default function WorkflowsComponent(props) {
  const { instance, accounts } = useMsal();
  const activeAccount = accounts[0];
  const userId = activeAccount?.localAccountId;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { workflowId } = useParams();
  const ability = useAbility();

  const isEditMode = workflowId && workflowId !== "add";
  const isCreateMode = !isEditMode;

  const [workflow, setWorkflow] = useState({
    scope: "",
    triggerEvent: "",
    dataQuery: {
      url: "",
      method: "POST",
      headers: {},
      mapping: {},
    },
    webhook: {
      url: "",
      method: "POST",
      headers: {},
      body: {},
    },
  });

  const [formValid, setFormValid] = useState(false);

  // Permission check
  const canCreate = props.SCOPES_NAMES?.some((scope) =>
    ability?.can("create", `Flow.main@${scope}`)
  );
  const canUpdate =
    isEditMode && workflow.scope && ability?.can("update", `Flow.main@${workflow.scope}`);

  useEffect(() => {
    if (isEditMode) {
      // Mode Edit: charger depuis location.state ou API
      if (location.state?.workflow) {
        setWorkflow(location.state.workflow);
      } else {
        fetchWorkflow();
      }
    }
  }, [workflowId]);

  const fetchWorkflow = async () => {
    if (!workflowId || !props.ACTIVE_TENANT) return;

  
    try {
      const token = await getAccessToken(instance, activeAccount);
      // On ne connaît pas le scope, donc chercher dans tous les scopes
      for (const scope of props.SCOPES_NAMES || []) {
        const result = await getWorkflow(props.ACTIVE_TENANT, scope, workflowId, token);
        if (result) {
          setWorkflow(result);
          break;
        }
      }
    } catch (error) {
      console.error("Error fetching workflow:", error);
      console.error(t("ERROR_FETCHING_WORKFLOW"));
    } 
  };

  const handleSubmit = async () => {
    if (!formValid) {
      console.error(t("PLEASE_FILL_REQUIRED_FIELDS"));
      return;
    }

    if (isCreateMode && !canCreate) {
      console.error(t("NO_PERMISSION_CREATE"));
      return;
    }

    if (isEditMode && !canUpdate) {
      console.error(t("NO_PERMISSION_UPDATE"));
      return;
    }

   
    try {
      const token = await getAccessToken(instance, activeAccount);

      if (isCreateMode) {
        const result = await createWorkflow(
          props.ACTIVE_TENANT,
          workflow.scope,
          workflow,
          token
        );

        if (result.success && result.message === "created") {
          // Mettre à jour le store Redux avec le nouveau workflow
          if (result.data && props.setWorkflows && props.WORKFLOWS) {
            props.setWorkflows([...props.WORKFLOWS, result.data]);
          }
          console.log(result.message || t("WORKFLOW_CREATED_SUCCESS"));
          navigate("/workflows");
        } else {
          console.error(result.message || t("ERROR_CREATING_WORKFLOW"));
        }
      } else {
        const result = await updateWorkflow(
          props.ACTIVE_TENANT,
          workflow.scope,
          workflowId,
          workflow,
          token
        );

        if (result.success && result.message === "updated") {
          // Mettre à jour le store Redux avec le workflow modifié
          if (result.data && props.setWorkflows && props.WORKFLOWS) {
            props.setWorkflows(
              props.WORKFLOWS.map((w) => (w.id === workflowId ? result.data : w))
            );
          }
          console.log(result.message || t("WORKFLOW_UPDATED_SUCCESS"));
          navigate("/workflows");
        } else {
          console.error(result.message || t("ERROR_UPDATING_WORKFLOW"));
        }
      }
    } catch (error) {
      console.error("Error saving workflow:", error);
      console.error(t("ERROR_SAVING_WORKFLOW"));
    } 
  };

  const handleCancel = () => {
    navigate("/workflows");
  };

  

  return (
    <div className="workflows-component-container">
      <div className="action-buttons-workflow">
        <Button
          appearance="secondary"
          icon={<Dismiss20Regular />}
          onClick={handleCancel}
        >
          {t("cancel")}
        </Button>
        <Button
          appearance="primary"
          icon={<Save20Regular />}
          onClick={handleSubmit}
          disabled={!formValid}
        >
          {t("save")}
        </Button>
      </div>

      <WorkflowForm
        workflow={workflow}
        setWorkflow={setWorkflow}
        isUpdate={isEditMode}
        setFormValid={setFormValid}
        SCOPES_NAMES={props.SCOPES_NAMES}
      />
    </div>
  );
}
